export default __webpack_public_path__ + "static/catalog-3fef8761ead4d84e7fdd8846861b029e.png";